import { render, staticRenderFns } from "./response-comment-add.vue?vue&type=template&id=6dbd529c&"
import script from "./response-comment-add.vue?vue&type=script&lang=js&"
export * from "./response-comment-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports